import { render, staticRenderFns } from "./ProductionDetailJQuery.vue?vue&type=template&id=2be4b277&scoped=true&"
import script from "./ProductionDetailJQuery.vue?vue&type=script&lang=js&"
export * from "./ProductionDetailJQuery.vue?vue&type=script&lang=js&"
import style0 from "./ProductionDetailJQuery.vue?vue&type=style&index=0&id=2be4b277&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be4b277",
  null
  
)

export default component.exports